import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-timeline',
  templateUrl: './app-timeline.component.html',
  styleUrls: ['./app-timeline.component.css']
})
export class AppTimelineComponent implements OnInit {
  events = [
    { status: 'Initié', date: '12/06/2024', comment: 'Portail' },
    { status: 'Complement', date: '15/06/2024', comment: 'Commentaire' },
    { status: 'En vérification', date: '17/06/2024', comment: 'Commentaire' },
    { status: 'En traitement', date: '17/06/2024', comment: 'Commentaire' },
    { status: 'Produite', date: '20/06/2024', comment: 'Commentaire' },
    { status: 'Remise', date: '26/06/2024', comment: 'Commentaire' }
  ];
  constructor() { }

  ngOnInit(): void {
  }

  getBackgroundColor(status: string): string {
    switch (status) {
      case 'Produite':
      case 'Remise':
        return '#c03b1d';
      case 'Complement':
        return '#d6da73';
      default:
        return '#649d4c'; // Default background color
    }
  }
}
